import React from 'react';
import intl from 'react-intl-universal';
import { Form, Button, Checkbox } from 'semantic-ui-react';
import classnames from 'classnames';
import * as styles from 'components/Settings/Sections.scss';
import WallPaperPanel from 'containers/WallPaperPanel/WallPaperPanelContainer';

interface Props {
  enableCustomBackground: Function;
  isCustomWallPaperEnabled: boolean;
  imagePreviewURL: string;
  isUpdateEnabled: boolean;
  saveWallpaper: Function;
}

interface State {
  updateDisabled: boolean;
}

class IconBackground extends React.Component<Props, State> {
  readonly state: State = {
    updateDisabled: true
  };

  componentDidUpdate(prevProps: Props) {
    if ((this.props.isCustomWallPaperEnabled !== prevProps.isCustomWallPaperEnabled) || (this.props.imagePreviewURL !== prevProps.imagePreviewURL)) {
      this.setState({ updateDisabled: false });
    }
  }

  render() {
    const { isCustomWallPaperEnabled, enableCustomBackground, imagePreviewURL, saveWallpaper } = this.props;
    return (
      <section className={styles.container} data-test="settingsSection.iconBackgrounds">
        <article className={styles.columns}>
          <div>
            <h6 className={styles.title} data-test="sectionTitle">{intl.get('iconBackgrounds')}</h6>
            <p className={styles.description}>{intl.get('iconBackgroundsHelper')}</p>
            <p className={classnames(styles.description, styles.em)}>{intl.get('iconBackgroundsHelper2')}</p>
            <Form>
              <div className={styles.formSection}>
                <Form.Field className={styles.optionGroup}>
                  <Checkbox
                    radio={true}
                    label={intl.get('noBackground')}
                    name="wallPaperGroup"
                    checked={!isCustomWallPaperEnabled}
                    onChange={() => enableCustomBackground(false)}
                  />
                </Form.Field>
                <Form.Field className={styles.optionGroup}>
                  <Checkbox
                    radio={true}
                    label={intl.get('customBackground')}
                    name="wallPaperGroup"
                    checked={isCustomWallPaperEnabled}
                    onChange={() => enableCustomBackground(true)}
                  />
                </Form.Field>
              </div>
            </Form>
          </div>
          <div className={styles.formSection}>
            <WallPaperPanel />
            <div className={styles.buttonContainer}>
              <Button
                data-test="sectionBtnSubmit"
                disabled={!this.props.isUpdateEnabled || this.state.updateDisabled}
                name="btnUpdateCustomBackground"
                onClick={
                  (event: React.MouseEvent<HTMLButtonElement>) => {
                    saveWallpaper(imagePreviewURL, isCustomWallPaperEnabled);
                  }
                }
                role="button"
                type="button"
              >
                {intl.get('settingsButtonLabelUpdate')}
              </Button>
            </div>
          </div>
        </article>
      </section>
    );
  }
}

export default IconBackground;
